import { useState, useEffect } from 'react'
import { AdminAlert, AdminComingSoon, isNotBuiltYet } from '../AdminShared'
import { StatCard } from '../components/StatCard'
import { Skeleton } from '../components/Skeleton'
import { PlatformMetrics } from '../components/PlatformMetrics'
import { adminGetStats } from '../../../services/admin'

export function Overview({ onInvite }) {
  const [stats, setStats]       = useState(null)
  const [loading, setLoading]   = useState(true)
  const [error, setError]       = useState(null)

  useEffect(() => {
    adminGetStats()
      .then(setStats)
      .catch(err => setError(err))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="flex flex-col gap-8">
      {/* Security notice */}
      <div className="bg-surface border-4 border-on-background p-5 flex items-start gap-4" style={{ boxShadow: '4px 4px 0px 0px #d4af37' }}>
        <span className="material-symbols-outlined text-primary-container text-[24px] shrink-0 mt-0.5" style={{ fontVariationSettings: "'FILL' 1" }}>verified_user</span>
        <div>
          <p className="font-bold text-sm uppercase tracking-wider">Session Security Active</p>
          <p className="text-[12px] text-on-surface-variant mt-0.5">
            Token stored in <strong>HttpOnly · Secure</strong> cookie — invisible to JS. Auto-logout after <strong>15 min</strong> inactivity.
          </p>
        </div>
        <div className="ml-auto flex items-center gap-1.5 shrink-0">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="font-bold text-[9px] uppercase tracking-[0.14em] text-on-surface-variant">Live</span>
        </div>
      </div>

      {error && (
        isNotBuiltYet(error)
          ? <AdminComingSoon label="Dashboard metrics" />
          : <AdminAlert type="error" message={error.message} />
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-36" />)
        ) : (
          <>
            <StatCard icon="group"    label="Total Users"       value={stats?.totalUsers}      badge={stats?.usersBadge}      gold />
            <StatCard icon="article"  label="Total Posts"       value={stats?.totalPosts}      badge={stats?.postsBadge}      gold />
            <StatCard icon="groups"   label="Active Users Today" value={stats?.dailyActiveUsers} badge={stats?.activeUsersBadge}    />
            <StatCard icon="visibility" label="Total Views"     value={stats?.totalViews} />
          </>
        )}
      </div>

      {/* Platform activity metrics */}
      <PlatformMetrics stats={stats} loading={loading} />

      {/* Two-col lower */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Admin management */}
        <div className="bg-surface border-4 border-on-background p-6 flex flex-col gap-4" style={{ boxShadow: '4px 4px 0px 0px var(--neo-border-color)' }}>
          <div className="flex items-center gap-3">
            <span className="material-symbols-outlined text-primary-container text-[22px]" style={{ fontVariationSettings: "'FILL' 1" }}>manage_accounts</span>
            <h2 className="font-extrabold text-[15px] uppercase tracking-tight">Admin Management</h2>
          </div>
          <p className="text-[12px] text-on-surface-variant leading-relaxed">
            Invite new admins via one-time cryptographic token links. Tokens expire after 24 hours and are permanently destroyed on use.
          </p>
          {onInvite ? (
            <button onClick={onInvite}
              className="flex items-center justify-center gap-2 py-3 bg-primary-container text-on-primary-fixed font-bold text-[12px] uppercase tracking-widest border-4 border-on-background hover:brightness-105 transition-all"
              style={{ boxShadow: '3px 3px 0px 0px var(--neo-border-color)' }}>
              <span className="material-symbols-outlined text-[16px]">person_add</span>
              Invite a New Admin
            </button>
          ) : (
            <p className="text-[12px] font-bold uppercase tracking-widest text-on-surface-variant border-2 border-dashed border-on-background/25 p-3 text-center">Only the super admin can invite admins</p>
          )}
        </div>

        {/* Security log */}
        <div className="bg-surface border-4 border-on-background p-6 flex flex-col gap-4" style={{ boxShadow: '4px 4px 0px 0px var(--neo-border-color)' }}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="material-symbols-outlined text-primary-container text-[22px]" style={{ fontVariationSettings: "'FILL' 1" }}>security</span>
              <h2 className="font-extrabold text-[15px] uppercase tracking-tight">Security Log</h2>
            </div>
            <span className="font-bold text-[9px] uppercase tracking-widest text-on-surface-variant border-2 border-on-background/15 px-2 py-1">Last 24h</span>
          </div>
          <AdminComingSoon label="Activity log" />
        </div>
      </div>
    </div>
  )
}